module.exports = __webpack_public_path__ + "img/font_icon.3a457bb5.svg";